// ─────────────────────────────────────────────────────────────────────────
// Folios y ambiente — cuántos folios quedan por tipo de documento en SimpleFactura.
// Antes era la cabecera de la pestaña Emisiones de Contabilidad.
// Los datos los carga Facturacion.js (GET /dte/folios) y los comparte con el
// indicador de ambiente de la cabecera.
// ─────────────────────────────────────────────────────────────────────────
import React from "react";
import useIsMobile from "../../hooks/useIsMobile";
import { S, fmtDH } from "./ui";

const TIPOS = { 33: { label: "Factura", color: "#2ecc71" }, 61: { label: "Nota de crédito", color: "#e74c3c" }, 52: { label: "Guía de despacho", color: "#3498db" } };
const UMBRAL = 10;

const FoliosAmbiente = ({ data, cargando, onRefrescar, roles = [] }) => {
  const isMobile = useIsMobile();
  const esAdmin = roles.includes("admin");
  const hayPocos = Object.values(data?.folios || {}).some(n => n != null && n < UMBRAL);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <div style={{ ...S.label, display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <span>Folios disponibles</span>
        <span style={{ fontSize: 10, color: "#666", fontWeight: 400, textTransform: "none", letterSpacing: 0 }}>
          {data?.en ? `Última consulta: ${data.cache ? "en caché · " : ""}${fmtDH(data.en)}` : ""}
          {esAdmin && <button style={{ ...S.btn("#8a8a8a"), marginLeft: 8, padding: "2px 8px" }} onClick={onRefrescar} disabled={cargando}>{cargando ? "Consultando…" : "↻ Refrescar"}</button>}
        </span>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: 10 }}>
        {[33, 61, 52].map(t => {
          const n = data?.folios?.[t];
          const bajo = n != null && n < UMBRAL;
          const color = n == null ? "#666" : bajo ? "#e74c3c" : TIPOS[t].color;
          // Nunca "?": si no se pudo consultar se dice.
          const valor = cargando && !data ? "…" : n == null ? "sin consultar" : n;
          return (
            <div key={t} title={data?.errores?.[t] || ""} style={{ ...S.card, borderColor: bajo ? "#4a2020" : "#2e2e2e" }}>
              <div style={S.label}>{TIPOS[t].label} · {t}</div>
              <div style={{ fontSize: n == null ? 13 : 26, fontWeight: 800, color, marginTop: 4, fontVariantNumeric: "tabular-nums" }}>{valor}</div>
              {bajo && <div style={{ fontSize: 11, color: "#e74c3c", marginTop: 4, fontWeight: 700 }}>Quedan menos de {UMBRAL} folios.</div>}
              {data?.errores?.[t] && <div style={{ fontSize: 10, color: "#f39c12", marginTop: 4 }}>{String(data.errores[t])}</div>}
            </div>
          );
        })}
      </div>
      {hayPocos && <div style={{ fontSize: 11, color: "#e74c3c" }}>Hay tipos con pocos folios: solicite la carga de un CAF nuevo antes de que se agoten.</div>}
      <div style={{ fontSize: 11, color: "#8a8a8a" }}>CAF: los folios se cargan en el portal de SimpleFactura.</div>
    </div>
  );
};

export default FoliosAmbiente;
